import { Button, Dropdown } from 'antd';
import classNames from 'classnames';
import { UpOutlined } from '@ant-design/icons';
import { IconFont } from '../../../component/icon-font';
import { getAntdDropdownMenu, getAntdItem } from './video-footer-utils';
import EndCallIcon from '../../../component/svgs/new/end-call.svg';
import { CSSProperties } from 'react';

const { Button: DropdownButton } = Dropdown;
interface LeaveButtonProps {
  onLeaveClick: () => void;
  onEndClick: () => void;
  isHost: boolean;
}

const iconLeave = () => {
  return (
    <div style={styles.leaveBtn}>
      <img
        src={EndCallIcon}
        alt="magic"
        style={{
          width: 18,
          height: 18
        }}
      />
      <span style={styles.btnText}>Leave</span>
    </div>
  );
};

const LeaveButton = (props: LeaveButtonProps) => {
  const { onLeaveClick, onEndClick, isHost } = props;

  return isHost ? (
    <DropdownButton
      className="vc-dropdown-button leave-button press-effect-btn"
      size="large"
      menu={getAntdDropdownMenu([getAntdItem('End session', 'end')], onEndClick)}
      trigger={['click']}
      type="ghost"
      onClick={onLeaveClick}
      icon={<UpOutlined />}
      placement="topLeft"
    >
      {iconLeave()}
    </DropdownButton>
  ) : (
    <Button
      className={classNames('vc-button leave-button press-effect-btn')}
      icon={iconLeave()}
      // eslint-disable-next-line react/jsx-boolean-value
      ghost={true}
      shape="circle"
      size="large"
      onClick={onLeaveClick}
      title="Leave"
    />
  );
};

export { LeaveButton };

const styles: Record<string, CSSProperties> = {
  leaveBtn: {
    height: '36px',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    border: 'none',
    background: '#E7000B',
    marginRight: 10,
    padding: '7px 12px'
  },
  btnText: {
    marginLeft: 8,
    fontSize: 16,
    color: '#fff',
    fontWeight: '400'
  }
};
